import { getDataForCreateKubernetes } from './api';
import { kubernetesKeys } from './keys';

export const kubernetesDataForCreateQueryOptions = () => ({
  queryKey: kubernetesKeys.dataForCreate(),
  queryFn: () => getDataForCreateKubernetes(),
});
